module.exports = __webpack_public_path__ + "static/media/Computer.4c5a8349.mp4";